(() => {
  const GIFT_VARIANT_ID = 52781623804251;
  const THRESHOLD = 7500; // €75 in cents
  let isUpdating = false;

  async function getCart() {
    const response = await fetch('/cart.js');
    return response.json();
  }

  async function addGift() {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: [{
          id: GIFT_VARIANT_ID,
          quantity: 1,
          properties: {
            '_ra_free_gift': 'true'
          }
        }]
      })
    });
  }

  async function removeGift(lineKey) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: lineKey,
        quantity: 0
      })
    });
  }

  async function checkFreeGift() {
    if (isUpdating) return;

    try {
      isUpdating = true;

      const cart = await getCart();

      const giftLine = cart.items.find(
        item =>
          item.variant_id === GIFT_VARIANT_ID &&
          item.properties &&
          item.properties._ra_free_gift === 'true'
      );

      // Calculate cart value excluding the free-gift variant.
      const qualifyingTotal = cart.items.reduce((total, item) => {
        if (item.variant_id === GIFT_VARIANT_ID) return total;
        return total + item.final_line_price;
      }, 0);

      if (qualifyingTotal >= THRESHOLD && !giftLine) {
        await addGift();
        window.location.reload();
        return;
      }

      if (qualifyingTotal < THRESHOLD && giftLine) {
        await removeGift(giftLine.key);
        window.location.reload();
      }
    } catch (error) {
      console.error('Ra Lumière free gift:', error);
    } finally {
      isUpdating = false;
    }
  }

  document.addEventListener('DOMContentLoaded', checkFreeGift);

  document.addEventListener('change', () => {
    setTimeout(checkFreeGift, 800);
  });

  document.addEventListener('click', () => {
    setTimeout(checkFreeGift, 800);
  });
})();